import {_} from 'vue-underscore';

export default {
    methods: {
        imageUrl (filename)
        {
            return 'images/' + filename;
        },
        apiImageUrl (filename)
        {
            if(filename) {
                if (filename.startsWith('http')) {
                    return filename;
                } else if(filename.startsWith('/uploaded')) {
                    return API_ROOT + filename;
                } else {
                    if (filename.startsWith('/')) {
                        filename = filename.substring(1);
                    }
                    return API_ROOT + 'uploaded/store/images/' + filename;
                }
            } else {
                return '';
            }
        },
        focusTarget(event) {
            event.preventDefault();
            if(event.target) event.target.focus();
        },
        sortSizes(sizes) {
            if(sizes.lenght < 2) return sizes;
            
            let orderedSizes = sizes.map(size => {
                const matchIndex = size.product_option_value_title.match(/([0-9.]+)/i);
                
                return {
                    index: matchIndex ? matchIndex[0] === '00' ? -1 : new Number(matchIndex[0]) : null,
                    size
                };
            });

            if(!orderedSizes.every(sizeObj => sizeObj.index !== null)) {
                orderedSizes = sizes.map(size => {
                    const matchIndex = sizeLetters.find(sizeLetterValue => sizeLetterValue.regex.test(size.product_option_value_title));
                    const countX = size.product_option_value_title.split('').filter(letter => letter.toLowerCase() === 'x').length + 1;
                    return {
                        index: matchIndex ? matchIndex.index * countX : size.product_option_value_title,
                        size
                    };
                });
            }

            if(orderedSizes) {
                return orderedSizes
                    .sort((sizeA, sizeB) => sizeA.index - sizeB.index)
                    .map(sizeObj => sizeObj.size);
            }
                
            return sizes;
        },
        delay(promiseFn, msDelay) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve(promiseFn());
                }, msDelay);
            });
        },
        setScreenNameForAnalytics(screenName) {
            if (typeof window.FirebasePlugin !== 'undefined') {
                window.FirebasePlugin.setScreenName(screenName);
            }
        },
        setScreenNameToLastRoute() {
            let screenName = this.$route.path.replace('/', '').replace('-', ' ');
            if (screenName == '') {
                screenName = 'home';
            }
            
            if (typeof window.FirebasePlugin !== 'undefined') {
                window.FirebasePlugin.setScreenName(screenName);
            }
        }
    }
}

const sizeLetters = [
    {
        regex: /s{1}|small/i,
        index: -1
    },
    {
        regex: /m{1}|medium/i,
        index: 0
    },
    {
        regex: /l{1}|large/i,
        index: 1
    }
];
